export default __webpack_public_path__ + "static/media/IM.13b733fe.ico";